import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import React, { FC, useState } from 'react';
import { IOrderEntity } from '../../../../Services/api/orders/orders.interface';
import { Flex } from '../../../Flex/flex.component';
import { ISaleEntity } from '../../../../Pages/Financial/Details/financial-details.hook';

interface ISaleProductTableProps {
    sale: ISaleEntity
}

const HCP_FLOW_LABELS: Record<string, string> = {
  AWAITING_ART: 'Arte',
  SHEET: 'Cartela',
  PRODUCTION: 'Produção',
  MACHINE_PRODUCTION: 'Produção de Máquinas',
  LOGISTICS: 'Logística',
}


const SaleProductTable : FC<ISaleProductTableProps> = ({ sale }) => {
  const [showNewVariant, setShowNewVariant] = useState(false)

  const getHCPFlowLabel = (flow?: string | null) => {
    if (!flow) return 'Não iniciado'
    return HCP_FLOW_LABELS[flow] ?? flow
  }

  const formatHCPDate = (value?: string | null) => {
    if (!value) return '—'
    const date = new Date(value)
    if (Number.isNaN(date.getTime())) return value
    return date.toLocaleString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    })
  }

  const getHCPFinishedLabel = (value?: boolean | null) => {
    if (value === true) return 'Finalizado'
    if (value === false) return 'Em aberto'
    return 'Não informado'
  }

  function createData(item: any) : any {
    return item
  }

  function Row(props: { row: ReturnType<typeof createData> }) {
    const { row } = props;
    const [open, setOpen] = React.useState(false);
  
    return (
      <React.Fragment>
        <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
         
          <TableCell component="th" scope="row" width={'90%'}>

            <Flex sx={{ alignItems:  'center'}}>
                <Box component='img' src={row.image} sx={{ width: '80px', height: '80px', objectFit: 'contain'}} />
                <Flex sx={{ height: '100%', alignItems: 'center', marginLeft: '20px'}}>
                  <Typography>{row.name}</Typography>
                </Flex>
                
            </Flex>
           
          </TableCell>
          
          <TableCell  width={'10%'} >
            <IconButton
              aria-label="expand row"
              size="small"
              onClick={() => setOpen(!open)}
            >
              {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
            <Collapse in={open} timeout="auto" unmountOnExit>
              <Box sx={{ margin: 1 }}>
                

                <Box>
                  {/* <Typography sx={{ fontSize: '16px'}} gutterBottom component="div">Sku: {row.sku}</Typography> */}
                  <Typography sx={{ fontSize: '16px' }} gutterBottom component="div">Quantidade: {row.quantity > 0 ? row.quantity : '-'} unidade(s)</Typography>
                  <Typography sx={{ fontSize: '16px' }} gutterBottom component="div">Preço unitário: {row.price_unit || '-'}</Typography>
                  <Typography sx={{ fontSize: '16px' }} gutterBottom component="div">Total: {row.total || '-'}</Typography>
                </Box>

                <Box sx={{ mt: 2, pt: 2, borderTop: '1px solid rgba(0,0,0,0.08)' }}>
                  <Typography sx={{ fontSize: '16px', fontWeight: 700, mb: 1 }} gutterBottom component="div">
                    HCP
                  </Typography>
                  <Box sx={{ display: 'flex', gap: 0.75, flexWrap: 'wrap', mb: 1.25 }}>
                    <Chip
                      label={getHCPFlowLabel(row.hcpCurrentFlow)}
                      size="small"
                      sx={{
                        height: 22,
                        fontSize: '0.72rem',
                        fontWeight: 700,
                        bgcolor: row.hcpCurrentFlow ? 'rgba(21,101,192,0.10)' : 'rgba(0,0,0,0.06)',
                        color: row.hcpCurrentFlow ? '#1565c0' : 'text.secondary',
                      }}
                    />
                    {row.hcpCurrentFlowDisplayCode && (
                      <Chip
                        label={row.hcpCurrentFlowDisplayCode}
                        size="small"
                        sx={{ height: 22, fontSize: '0.72rem', bgcolor: '#eceff3', color: 'text.secondary' }}
                      />
                    )}
                    <Chip
                      label={getHCPFinishedLabel(row.hcpFinished)}
                      size="small"
                      sx={{ height: 22, fontSize: '0.72rem', bgcolor: '#eceff3', color: 'text.secondary' }}
                    />
                  </Box>
                  <Typography sx={{ fontSize: '15px' }} gutterBottom component="div">
                    Status: {row.hcpCurrentFlowStatusName || 'Sem status HCP'}
                  </Typography>
                  <Typography sx={{ fontSize: '15px' }} gutterBottom component="div">
                    Início: {formatHCPDate(row.hcpCurrentFlowStartedAt)}
                  </Typography>
                  <Typography sx={{ fontSize: '15px' }} gutterBottom component="div">
                    Prazo: {formatHCPDate(row.hcpCurrentFlowDeadline)}
                  </Typography>
                  {row.productOrderCode && (
                    <Typography sx={{ fontSize: '15px' }} gutterBottom component="div">
                      Posição no pedido: {row.productOrderCode}
                    </Typography>
                  )}
                </Box>


                {/* <Box sx={{ marginTop: '40px', borderBottom: 'solid 1px #dedede', marginBottom: '20px'}}>
                  <Typography variant="h6" gutterBottom component="div">Arte</Typography>
                </Box> */}
               
                
              </Box>
            </Collapse>
          </TableCell>
        </TableRow>
      </React.Fragment>
    );
  }

  const rows = (sale?.products ?? []).map(i => createData(i))

  const handleToggle = () => {
    setShowNewVariant(prev => !prev)
  }
   
      return(
        <>
        {/* <CubageVariantFormDrawer open={showNewVariant} handleSelect={() => {}} onToggle={handleToggle} title='Nova Variação de Produto' subTitle='Preencha os dados abaixo' boxOptions={[{ label: 'test', value: '1'}]} cubageVariantSelected={cubageVariantSelected}  /> */}
       
        <TableContainer component={Paper}>
        <Table aria-label="collapsible table">
            <TableHead>
            <TableRow>
                
                <TableCell align='left' sx={{ fontWeight: 'bold', fontSize: '19px'}} width={'80%'}>Produtos</TableCell>
              
                <TableCell width='20%' />
              
            </TableRow>
            </TableHead>
            <TableBody>
            {rows.length ? rows.map((row) => (
                <Row key={row.id || row.name} row={row} />
            )) : (
              <TableRow>
                <TableCell colSpan={2}>
                  <Typography color="text.secondary">Nenhum produto encontrado para este pedido.</Typography>
                </TableCell>
              </TableRow>
            )}
            </TableBody>
        </Table>
        </TableContainer>
        </>
      )

}

export { SaleProductTable };
